export const VALID_CHARACTER_AMOUNT = 125;
